import axios from '@/libs/api.request'

export const page = (data) => {
  return axios.request({
    url: '/ad/unitGeneral/page',
    method: 'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/ad-unit-general.js